const BASE = process.env.ENV === 'preview' ? 'api/gp-user-staging' : 'api/gp-user'
const urls = {
  /*
  * 关联进页面群组
  *   groupIds (关联群组)
  *   userId
  * */
  addMemberToGroup: 'get /api/inner/user/addMemberToGroup',
  // 通过userId获取用户的工号tgId
  getTgIdByUserId: 'get /api/tg/getTgIdByUserId',
  // 没有手机号时加入通讯录
  addMember: 'post /contacts/addMember'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS



// WEBPACK FOOTER //
// ./src/apis/api-urls/gp-user.js